// Spielen-Ansicht: Hinweis auf eine eigene Startstellung (ab hier weiterspielen) und auf „Spiel wie …“.
import { h, type VNode } from 'snabbdom';
import { t } from '../i18n';
import type { PlayCtrl } from '../playctrl';

export function startInfo(c: PlayCtrl): VNode | null {
  if (!c.start) return null;
  return h('div.fld', h('div.row', [
    h('span', t('Startstellung: {s}', { s: c.start.label })),
    h('button.link', { on: { click: () => ((c.start = null), c.redraw()) } }, t('Grundstellung')),
  ]));
}

export function guessHint(): VNode {
  return h('div.fld', h('p.muted.small', [
    t('Berühmte Partien: in der Bibliothek eine Partie öffnen, dann „Spiel wie …“ oder „Ab hier weiterspielen“.') + ' ',
    h('a.link', { attrs: { href: '#/bibliothek' } }, t('Zur Bibliothek')),
  ]));
}
